import React, { useState } from 'react'

import { StyledDefault } from './StyledComponents'
import no_result_found from "../assets/images/icons/no_result.svg"
import img_logo from "../assets/images/logo/logo192.png"
import { useTranslation } from 'react-i18next'
import { BlogData } from '../pages/Blog/BlogData'

const SearchInfoModal = ({ setModalSearchOpen, handleOverlayClick, modalSearchRef }) => {
  const { t } = useTranslation()

  const blogData = BlogData()

  const [searchTerm, setSearchTerm] = useState('');

  const highlightMatches = (text, searchTerm) => {
    const lowerText = text.toLowerCase();
    const lowerSearchTerm = searchTerm.toLowerCase();

    if (!lowerSearchTerm || !lowerText.includes(lowerSearchTerm)) {
      return <>{text}</>; // Return the original text if no match or search term is empty
    }

    const parts = text.split(new RegExp(`(${searchTerm})`, 'i'));

    return (
      <>
        {parts.map((part, index) => (
          part.toLowerCase() === lowerSearchTerm ? (
            <span key={index} className='highlight'>
              {part}
            </span>
          ) : (
            <span key={index}>
              {part}
            </span>
          )
        ))}
      </>
    );
  };

  return (
    <div className='search-wrapper search-modal' onClick={handleOverlayClick} >
      <div className='search-wrapper-content' id="searchModal" ref={modalSearchRef}>
        <div className='search-input-body'>
          {searchTerm.trim() === '' ?
            <label htmlFor="search-modal-input" style={{ marginTop: "2px" }}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height="18" width="18" className="search-icon" data-type="search" style={{ display: "initial" }}><path fill="currentcolor" d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8.0 45.3s-32.8 12.5-45.3.0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9.0 208S93.1.0 208 0 416 93.1 416 208zM208 352a144 144 0 100-288 144 144 0 100 288z"></path></svg>
            </label> :
            <label htmlFor="search-modal-input" style={{ marginTop: "2px" }} onClick={() => setSearchTerm('')} className='search-modal-remove-input'>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height="18" width="18" className="search-reset" data-type="reset" style={{ display: "initial" }}>
                <path fill="currentcolor" d="M256 512A256 256 0 10256 0a256 256 0 100 512zM175 175c9.4-9.4 24.6-9.4 33.9.0l47 47 47-47c9.4-9.4 24.6-9.4 33.9.0s9.4 24.6.0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6.0 33.9s-24.6 9.4-33.9.0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9.0s-9.4-24.6.0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6.0-33.9z">
                </path>
              </svg>
            </label>
          }
          <input type="text" placeholder={t('modal.search-form.search-website')} id="searchInput" onChange={(e) => {
            setSearchTerm(e.target.value)
          }} value={searchTerm} />
        </div>
        <div className='search-wrapper-body'>
          <div className='search-result'>
            {/* <div className='search-result-group'>
              <p></p> */}
            {
              (() => {
                if (searchTerm.trim() === '') {
                  return <div className='search-result-empty'>{t('modal.search-form.type-something')}</div>;
                }

                const filteredData = blogData.filter((val) => {
                  return (
                    val.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    val.content.toLowerCase().includes(searchTerm.toLowerCase())
                  );
                });

                if (filteredData.length === 0) {
                  return <div className='search-no-results-message'>
                    <img src={no_result_found} alt="" className='mb-10' />
                    <p>{t('modal.search-form.no-result-for')}"<span className='font-weight-semi-bold'>{searchTerm}</span>"</p>
                  </div>;
                }

                return filteredData.map((val) => (
                  <StyledDefault href={val.link}  key={val.link}>
                    <div className='search-result-item'>
                      {val.image === ""
                      ?
                      <img src={img_logo} alt='' className='img-responsive search-img' width="100px" />
                      :
                      <img src={val.image} alt='' className='img-responsive search-img' />
                      }
                      <div className='search-content-block'>
                        <p className='search-title'>{highlightMatches(val.title, searchTerm)}</p>
                        <p className='search-description pt-10'>{highlightMatches(val.content, searchTerm)}</p>
                      </div>
                    </div>
                  </StyledDefault>
                ));
              })()
            }
            {/* </div> */}
          </div>

        </div>
        <div className='search-wrapper-footer'>
          <span className='mr-5 font-12'><kbd>ESC</kbd>{t('modal.search-form.to-close')}</span>
        </div>
      </div>
    </div>
  )
}



export default SearchInfoModal